import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71d45262&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d45262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d45262')) {
      api.createRecord('71d45262', component.options)
    } else {
      api.reload('71d45262', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71d45262&scoped=true", function () {
      api.rerender('71d45262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/feedback/index.vue"
export default component.exports